// Bell backend: GET /api/v1/notifications — newest-first page +
// unread_count. Polls every 60s while the tab is open (matches the
// server's dedicated notification_read 60/min bucket) so the badge
// stays roughly live without websockets.

import { useQuery } from "@tanstack/react-query";

import { attachRequestIdToScope } from "../../lib/api-client";

export type Notification = {
  id: string;
  kind: string;
  title: string;
  body: string | null;
  /** SPA-relative route to navigate to on click; null = non-navigating. */
  link_path: string | null;
  created_at: string;
  read_at: string | null;
};

export type NotificationsResponse = {
  data: Notification[];
  unread_count: number;
  page: number;
  page_size: number;
  has_next: boolean;
};

async function fetchNotifications(): Promise<NotificationsResponse> {
  const response = await fetch("/api/v1/notifications?page=1&page_size=20", {
    credentials: "include",
  });
  attachRequestIdToScope(response);
  if (!response.ok) {
    throw new Error(`Notifications fetch failed (HTTP ${response.status})`);
  }
  return (await response.json()) as NotificationsResponse;
}

export function useNotifications(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ["notifications"],
    queryFn: fetchNotifications,
    enabled: options?.enabled ?? true,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    retry: false,
  });
}
